import PropTypes from "prop-types";
import { forwardRef } from "react";
// @mui
import { useTheme } from "@mui/material/styles";
import Link from "@mui/material/Link";
import Box from "@mui/material/Box";
// routes
import { RouterLink } from "src/routes/components";

// ----------------------------------------------------------------------

// Logo Consuman Evolution (branding 2026).
//
// Hay dos tintas oficiales y se eligen por el FONDO sobre el que se apoya el
// logo, no por el modo del tema: el sidebar, por ejemplo, es oscuro en los dos
// modos y siempre necesita la versión con degradado.
//   onLight -> negro #1F1F1F
//   onDark  -> degradado #AE6BFF -> #6F26FF
//
// `variant`: "full" es el lockup completo (símbolo + consuman® + EVOLUTION),
// "mark" es sólo el símbolo, para espacios angostos como el sidebar mini.
const SOURCES = {
  full: {
    onLight: "/logo/logo-evolution-on-light.svg",
    onDark: "/logo/logo-evolution-on-dark.svg",
  },
  mark: {
    onLight: "/logo/logo-mark-on-light.svg",
    onDark: "/logo/logo-mark-on-dark.svg",
  },
};

// Ancho por defecto de cada variante. El alto lo resuelve el ratio del asset
// (el lockup es 3.79:1 y el símbolo es prácticamente cuadrado), así que nunca
// hay que fijar los dos o el logo se deforma.
const DEFAULT_WIDTH = { full: 168, mark: 40 };

const Logo = forwardRef(
  ({ disabledLink = false, href = "/", variant = "full", onDark, sx, ...other }, ref) => {
    const theme = useTheme();

    // Si no lo dicen explícito, se asume que el fondo sigue al modo del tema.
    const onDarkSurface = onDark ?? theme.palette.mode === "dark";

    const ink = onDarkSurface ? "onDark" : "onLight";

    const logo = (
      <Box
        ref={ref}
        component="img"
        alt="Consuman Evolution"
        src={SOURCES[variant][ink]}
        sx={{
          flexShrink: 0,
          width: DEFAULT_WIDTH[variant],
          height: "auto",
          ...sx,
        }}
        {...other}
      />
    );

    if (disabledLink) {
      return logo;
    }

    return (
      <Link
        component={RouterLink}
        href={href}
        sx={{ display: "contents" }}
      >
        {logo}
      </Link>
    );
  }
);

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  href: PropTypes.string,
  onDark: PropTypes.bool,
  sx: PropTypes.object,
  variant: PropTypes.oneOf(["full", "mark"]),
};

export default Logo;
